import { FILEMETA_SPLIT_CHARACTER } from "@pdfking/constants/settings"

import type { FileData } from "../types/FileData"
import split_filename from "./split_filename"

export default (filename: string): FileData => {
  const { folder, basename, ext } = split_filename(filename)

  const [name, ...meta] = basename.split(FILEMETA_SPLIT_CHARACTER)
  return {
    basename: name || "",
    meta: meta.join(FILEMETA_SPLIT_CHARACTER),
    folder,
    ext,
  }
}
